const uuidRegex = '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}';
export const pcrPageRegex = `/app/(qpcr|pcr)/(${uuidRegex}|create)/(details|protocol|plate|results|report)`;
export default uuidRegex;
